import { HttpBackend, HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, Injectable, InjectionToken, Injector, Provider } from '@angular/core';
import { take, tap } from 'rxjs/operators'

export interface AppConfig {
  INTERNAL_URL: string;
  DOCUMENT_BASE_URL: string;
  USER_BASE_URL: string;
  AUTH_BASE_URL: string;
  AUTH_SERVICE_BASE_URL: string;
  SHIFT_BASE_URL: string;
  SHIFT_JAVA_URL: string;
  SCHEDULING_URL: string;
  BACKGROUND_CHECK_URL: string;
  SHIFT_URL: string;
  ISYSTEM_BASE_URL: string;
  ICARE_BASE_URL: string;
  ISYSTEM_BYPASS_GATEWAY_BASE_URL: string;
  SOCKET_BASE_URL: string;
  LEGACY_HUB_LOGIN: string;
  SERVICE: string;
  ALLOW_ANALYTICS: boolean;
  ALLOW_MARKETO: boolean;
  GOOGLE_KEY: string;
}
export const ICARE_APP_CONFIG = new InjectionToken<AppConfig>('icare app config');

@Injectable()
export class AppConfigService {
  private _appConfig: AppConfig = {} as AppConfig;

  constructor(private injector: Injector) { }

  public loadConfig(handler?: HttpBackend, config?: AppConfig): Promise<Object> {
    if (!this.isEmpty(config)) {
      this.setConfig(config);
      return;
    }
    const configPath = '/assets/config.json';
    if (handler) {
      return new HttpClient(handler).get(configPath).pipe(
        tap(config => this._appConfig = (config as AppConfig)),
        take(1)
      ).toPromise();
    }
    const http = this.injector.get(HttpClient);
    return http.get(configPath).pipe(
      tap((config) => this._appConfig = (config as AppConfig)),
      take(1)
    ).toPromise();
  }

  get config() {
    return this._appConfig;
  }

  /**
   * Mostly used for testing purposes
   * @param config
   */
  setConfig(config: AppConfig) {
    this._appConfig = config;
  }

  private isEmpty(config: AppConfig) {
    return !config || Object.getOwnPropertyNames(config).length === 0;
  }
}

export function configFileAppInitializer(appConfig: AppConfigService, http: HttpBackend, config: AppConfig) {
  return () => appConfig.loadConfig(http, config);
}

export function provideSimpleAppConfigInit(): Provider[] {
  return [
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: configFileAppInitializer,
      deps: [AppConfigService, HttpBackend, ICARE_APP_CONFIG]
    }
  ];
}


export function providerAppConfig(): Provider[] {
  return [
    AppConfigService
  ];
}
